import React, { useCallback, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { debounce } from "lodash";
import { useSelector } from "react-redux";

import { dateFormat } from "../../shared/helper/common";
import { Button, DataTable, Filter, SubHeading } from "../../shared/Components";
import {
  postAxios,
  postAxiosDataTable,
  putAxios,
} from "../../shared/Services/commonService";
import {
  API_ADD_MARKET,
  API_GET_LINE,
  API_UPDATE_MARKET,
} from "../../utils/api/ApiConstant";
import { CheckPasswordModal, CommonModal, ResultModal } from "../../shared/Components/Modal";

const Line = () => {
  const { pagePermission } = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useSelector((state) => state.user);
  const [headerSort, setHeaderSort] = useState({ column: 0, dir: "asc" });
  const [filterData, setFilterData] = useState({
    sportId: null,
    tournamentId: null,
    matchId: null,
  });
  const queryClient = useQueryClient();

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });
  const handleActions = async (
    newValue,
    token,
    rowData,
    apiAction,
    apiMethod,
    status
  ) => {
    const { marketType, marketId, match, assignTo } = rowData;

    const payload = {
      marketType,
      marketId,
      token,
      marketName: match?.name,
      status,
      userId: assignTo?.id,
    };
    const url = `${API_ADD_MARKET}/${apiAction}/${marketId}`;

    let res;
    if (apiMethod === "put") {
      res = await putAxios(url, payload);
    } else if (apiMethod === "post") {
      res = await postAxios(url, payload);
    }

    if (res) {
      setIsShow((prev) => ({
        ...prev,
        isOpen: false,
        rowData: {},
        name: "",
        modalTitle: "",
        apiFlag: !prev.apiFlag,
      }));
    }
  };
  const payload = useMemo(() => {
    return {
      draw: currentPage,
      length: recordsPerPage,
      search: {
        value: searchTerm,
        regex: false,
      },
      id: user?.user_id,
      columns: [
        {
          data: "",
          name: "",
          searchable: true,
          orderable: false,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "fancyName",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "match.name",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "createdAt",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "marketStartTime",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "isActive",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "isActive",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "allowBat",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "assignTo",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "fancyModeType",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
        {
          data: "displayOrder",
          name: "",
          searchable: true,
          orderable: true,
          search: {
            value: "",
            regex: false,
          },
        },
      ],
      order: [headerSort],
      matchName: filterData.matchId,
    };
  }, [currentPage, recordsPerPage, searchTerm, filterData.matchId, headerSort]);

  const { data, isLoading } = useQuery({
    queryKey: [
      "lineData",
      currentPage,
      recordsPerPage,
      searchTerm,
      filterData.matchId,
      headerSort,
    ],
    queryFn: async () => await postAxiosDataTable(API_GET_LINE, payload),
  });

  const columns = useMemo(
    () => [
      {
        accessorKey: "fancyName",
        header: "Line Name",
      },
      {
        accessorKey: "match.name",
        header: "Matches",
      },
      {
        header: "Result",
        cell: ({ row }) => {
          return (
            <Button
              className="btn_main "
              onClick={() =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: true,
                  rowData: row?.original,
                  name: "settlement",
                  modalTitle: "Settlement",
                  modalContent: ResultModal,
                }))
              }
              isDisabled={pagePermission?.result ? false : true}
            >
              R
            </Button>
          );
        },
      },
      {
        header: "Cancel",
        cell: ({ row, getValue }) => {
          const { match, marketType, displayName, fancyName } = row?.original;
          return (
            <CheckPasswordModal
              isBtn={true}
              onStatusChange={(newValue, token) => {
                const status = {
                  id: "MS930818",
                  name: "Cancelled",
                  value: "CANCELLED",
                };
                handleActions(
                  newValue,
                  token,
                  row?.original,
                  "cancel",
                  "put",
                  status
                );
              }}
              rowData={row?.original}
              getValue={getValue}
              btnText="X"
              btnclassName="btn-danger "
              modalTitle={`Cancel Market (${
                marketType === "Fancy"
                  ? fancyName
                  : marketType === "Bookmaker"
                  ? displayName
                  : marketType === "Match Odds"
                  ? displayName
                  : marketType
              })`}
            />
          );
        },
      },
      {
        accessorKey: "isActive",
        header: "isActive",
        cell: ({ getValue }) => (
          <div className="form-switch form-switch-sm">
            <input
              className="form-check-input"
              type="checkbox"
              checked={getValue()}
              onChange={() => console.log(123)}
            />
          </div>
        ),
      },
      {
        accessorKey: "allowBat",
        header: "Allow Bat",
        cell: ({ getValue }) => (
          <div className="form-switch form-switch-sm">
            <input
              className="form-check-input"
              type="checkbox"
              checked={getValue()}
              onChange={() => console.log(123)}
            />
          </div>
        ),
      },
      {
        accessorKey: "displayOrder",
        header: "Display Order",
        cell: ({ getValue, row }) => (
          <div className="d-flex align-items-center">
            <input
              className="form-control input_cuter_box "
              type="text"
              value={row?.original?.displayOrder}
              id="example-text-input"
            ></input>
            <div className="form-switch form-switch-sm">
              <input
                className="form-check-input"
                type="checkbox"
                checked={getValue()}
                onChange={() => console.log(123)}
              />
            </div>
          </div>
        ),
      },
      {
        accessorKey: "assignTo.username",
        header: "AssignTo",
      },
      {
        accessorKey: "marketStatus.name",
        header: "Status",
        cell: ({ getValue }) => {
          const value = getValue();
          const flag = value ? "success" : "danger";
          return (
            <span className={`badge bg-${flag}-subtle text-${flag}`}>
              {value ? "OPEN" : "CLOSE"}
            </span>
          );
        },
      },
      {
        accessorKey: "marketStartTime",
        header: "Match Date",
        cell: ({ row }) =>
          dateFormat(row.original.marketStartTime).formattedDateTime,
      },
      {
        accessorKey: "createdAt",
        header: "Created Date",
        cell: ({ row }) => dateFormat(row.original.createdAt).formattedDateTime,
      },
      {
        accessorKey: "fancyModeType",
        header: "Type",
        cell: ({ getValue }) => (
          <span className={`badge bg-primary-subtle text-primary`}>
            {getValue()}
          </span>
        ),
      },
    ],
    []
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsperPage = (value) => {
    setRecordsPerPage(value);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleHeaderSort = ({ index, direction }) => {
    setHeaderSort({ column: index, dir: direction });
  };

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data?.docs || [],
      pages: data?.pages || 0,
    };
  };

  const handleFilterParams = (filterParams) => {
    const { match } = filterParams;
    setFilterData({
      ...filterData,
      matchId: match?.value,
    });
  };
  const handleQueryClient = (rowData, updatedRowData, key) => {
    return queryClient.setQueryData(
      [
        "lineData",
        currentPage,
        recordsPerPage,
        searchTerm,
        isShow.apiFlag,
        headerSort,
      ],
      (oldData) => {
        return {
          ...oldData,
          docs: oldData.docs.map((obj) =>
            obj._id === rowData._id
              ? { ...obj, [key]: updatedRowData[key] }
              : obj
          ),
        };
      }
    );
  };
  const handlePutRequest = async (rowData, value, key) => {
    const payload = { ...rowData, [key]: value };
    const url = `${API_UPDATE_MARKET}/${rowData?._id}`;
    const res = await putAxios(url, payload);

    if (res) {
      handleQueryClient(rowData, payload, key);
      setIsShow((prev) => ({
        ...prev,
        isOpen: false,
        rowData: {},
        name: "",
      }));
    }
  };
  return (
    <>
      <SubHeading subTitle="line list" isAddBtn={false} />
      <Filter
        allMatch={true}
        handleFilterParams={handleFilterParams}
        apiParam="Line"
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsperPage}
          recordsPerPage={recordsPerPage}
          onSearchChange={handleSearch}
          isLoading={isLoading}
          handleHeaderSort={handleHeaderSort}
        />
      </div>
      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              handlePutRequest,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Line;
